
import { ReactNode } from "react"

interface FormStepWrapperProps {
  children: ReactNode
}

export function FormStepWrapper({ children }: FormStepWrapperProps) {
  return (
    <div className="mt-4">
      {children}
    </div>
  )
}
